import { AnyAction } from 'redux';

import { SET_COLLECTION_ITEM_EVENTS } from './constants';

export const initialState = {
  collectionItemsEvents: {},
};

export const collectionsReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_COLLECTION_ITEM_EVENTS:
      return {
        ...state,
        collectionItemsEvents: {
          ...state.collectionItemsEvents,
          [action.eventType]: action.collectionItemId,
        },
      };
    default:
      return state;
  }
};
